import React, { useEffect, useState } from 'react'
import { ThemeProvider } from '@emotion/react'
import { EsDataTracker } from '@bizdotcom/event-stream-pixel'

// components
import ConfirmBannedBuyer from '@duplo/components/lib/Confirmation/Banned'
import ConfirmMatched from '@duplo/components/lib/Confirmation/Matched'
import ConfirmRepeatBuyer from '@duplo/components/lib/Confirmation/Repeat'
import ConfirmUnmatched from '@duplo/components/lib/Confirmation/Unmatched'
import ConfirmUnmatchedLeadExchange from '@duplo/components/lib/Confirmation/UnmatchedLeadExchange'
import { trackBiEvent } from '@duplo/utils/lib/tracking'
import useDynamicThemeLoader from '@duplo/components/lib/hooks/useDynamicThemeLoader'
import { getPageDataFromLocation, isBrowser } from '@duplo/utils/lib/browser'
import qs from 'qs'
import widgetTheme from '@duplo/themes/lib/widget'

function ConfirmationPage({ location }) {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		trackBiEvent()
	}, [])

	useEffect(() => {
		setMounted(true)
	}, [])

	if (!mounted) {
		return null
	}

	const pageData = getPageDataFromLocation(location)
	
	const { widgetColorOverrides, widgetVersion, colorpalettetheme } =
		isBrowser() && qs.parse(window.location.search, { ignoreQueryPrefix: true })
	const colorTheme = colorpalettetheme
	const hasColorPaletteOverrides = widgetColorOverrides && Object.keys(widgetColorOverrides).length
	const theme =  // eslint-disable-next-line react-hooks/rules-of-hooks
			  widgetTheme({ widgetColorPaletteName: colorTheme && typeof colorTheme === 'string' ? colorTheme : Array.isArray(colorTheme) && colorTheme[0], widgetColorOverrides, widgetVersion })


	if (!pageData || !theme) {
		return null
	}

	const {
		rfqConfig,
		rfqModuleData,
		rfqModuleData: { bannedBuyer = false, repeatBuyer = false, matchedCount, partnerName },
	} = pageData?.response

	const categoryId = rfqConfig?.catId
	let confirmComponent
	let esEventType = 'confirmation'

	switch (true) {
		case bannedBuyer:
			confirmComponent = <ConfirmBannedBuyer categoryId={categoryId} />
			esEventType = 'bannedbuyer'
			break
		case repeatBuyer:
			confirmComponent = <ConfirmRepeatBuyer categoryId={categoryId} {...rfqModuleData} />
			esEventType = 'repeatbuyer'
			break
		case !!partnerName:
			confirmComponent = <ConfirmUnmatchedLeadExchange categoryId={categoryId} partnerName={partnerName} />
			break
		case matchedCount > 0:
			confirmComponent = <ConfirmMatched categoryId={categoryId} {...rfqConfig} />
			break
		default:
			confirmComponent = (
				<ConfirmUnmatched categoryId={categoryId} {...rfqModuleData} appEnv={process.env.GATSBY_RFQ_API_BASE} qtPubId="1032" />
			)
			break
	}

	return (
		<ThemeProvider theme={theme}>
			{confirmComponent}
			<EsDataTracker
				app_version="V4"
				category_id={rfqConfig.catId}
				channel={rfqConfig.marketingId ? 'PPC' : 'SEO'}
				event_type={esEventType}
				request_number={rfqConfig.quoteId}
			/>
		</ThemeProvider>
	)
}

export default ConfirmationPage
